import { render, staticRenderFns } from "./CarrierFormModal.vue?vue&type=template&id=2a0b0281&scoped=true&"
import script from "./CarrierFormModal.vue?vue&type=script&lang=js&"
export * from "./CarrierFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b0281",
  null
  
)

export default component.exports